export default "__VITE_ASSET__Cq7wZfor__"